// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__WjxIt","content":"Consent_content__3LQAK","footer":"Consent_footer__1uhFI"};